import * as PropTypes from 'prop-types';
import * as React from 'react';
import { MobileDetection, Tracker } from '@reverbdotcom/discovery-ui';
import SoundcloudEmbed from './soundcloud_embed';
import * as SOUNDCLOUD_THUMB from '../../../images/icons/soundcloud-thumb.svg';

const BEGINNING = 'beginning';
const END = 'end';

class Fotorama extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      trackedImpressions: {},
      trackedClicks: {},
    };
  }

  componentDidMount() {
    $(this.refs.fotorama).fotorama(this.props);
    $(this.refs.fotorama).on('fotorama:ready', (e, fotoroma) => {
      this.trackVideoImpression(fotoroma.data[fotoroma.activeIndex]);
    });
    $(this.refs.fotorama).on('fotorama:show', (e, fotoroma) => {
      this.trackVideoImpression(fotoroma.data[fotoroma.activeIndex]);
    });
    $(this.refs.fotorama).on('fotorama:loadvideo', (e, fotoroma) => {
      this.trackVideoClick(fotoroma.data[fotoroma.activeIndex]);
    });
  }

  trackVideoImpression(activeMedia) {
    if (!activeMedia.video) { return; }
    if (this.state.trackedImpressions[activeMedia.url]) { return; }
    this.state.trackedImpressions[activeMedia.url] = true;

    Tracker.view({
      name: 'FotoramaVideo',
      type: 'video',
      ids: [activeMedia.url],
    });
  }

  trackVideoClick(video) {
    if (this.state.trackedClicks[video.url]) { return; }
    this.state.trackedClicks[video.url] = true;

    Tracker.trackInteraction({
      name: 'FotoramaVideo',
      type: 'video',
      url: video.url,
    });
  }

  images() {
    return this.props.images.map((link, i) => (
      <a
        href={link.href}
        data-full={link.full}
        key={i}
        data-url={link.href}
      >
        <img itemProp="image" alt={link.title} src={link.thumb} />;
      </a>
    ));
  }

  videos() {
    return this.props.videos.map((link, i) => (
      <a
        href={link.href}
        key={i}
        data-url={link.href}
      >
        {link.title}
      </a>
    ));
  }

  soundcloud() {
    return this.props.soundcloud.map((link, i) => (
      <div
        data-thumb={link.thumb || SOUNDCLOUD_THUMB}
        key={i}
        data-url={link.soundcloudUrl}
      >
        <SoundcloudEmbed url={link.soundcloudUrl} height="350px" />
      </div>
    ));
  }

  render() {
    if (this.props.videoPosition === BEGINNING) {
      return (
        <div className="fotorama" ref="fotorama">
          {this.videos()}
          {this.images()}
          {this.soundcloud()}
        </div>
      );
    }

    return (
      <div className="fotorama" ref="fotorama">
        {this.images()}
        {this.videos()}
        {this.soundcloud()}
      </div>
    );
  }
}

Fotorama.propTypes = {
  nav: PropTypes.oneOf(['dots', 'thumbs', false]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  click: PropTypes.bool,
  thumbheight: PropTypes.number,
  thumbwidth: PropTypes.number,
  thumbmargin: PropTypes.number,
  thumbborderwidth: PropTypes.number,
  keyboard: PropTypes.bool,
  allowfullscreen: PropTypes.bool,
  transitionduration: PropTypes.number,
  shadows: PropTypes.bool,
  swipe: PropTypes.bool,
  images: PropTypes.array,
  videos: PropTypes.array,
  soundcloud: PropTypes.array,
  videoPosition: PropTypes.oneOf([BEGINNING, END]),
};

Fotorama.defaultProps = {
  keyboard: true,
  width: '100%',
  height: '1/1',
  click: false,
  allowfullscreen: true,
  swipe: MobileDetection.isMobileBrowser(),
  transitionduration: 300,
  thumbheight: 64,
  thumbwidth: 64,
  thumbmargin: 4,
  thumbborderwidth: 0,
  shadows: true,
  loop: true,
  images: [],
  videos: [],
  soundcloud: [],
  videoPosition: END,
};

export default Fotorama;



// WEBPACK FOOTER //
// ./javascripts/components/shared/fotorama.jsx